<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sidebar_menus').toUpperCase() }} [{{model.Name}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card n_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('name')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="model.Name">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('type')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="model.Type">
                                        <option value="LEFT">LEFT</option>
                                        <option value="TOP">TOP</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div><label class="label-control blue"><input type="checkbox" v-model="model.Enabled"> {{$t('enabled')}}</label></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="btn-group btn-group-justified " role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="type=='Module'?'btn-primary':'btn-default'" @click="moduleClick">Select Module</button>
                                <button type="button" class="btn" :class="type=='Menu'?'btn-primary':'btn-default'" @click="menuClick">Select Menu</button>
                            </div>
                            <div style="padding: 10px 0;">
                                <template v-if="type=='Module'">
                                    <ul class="list-group list-group-x">
                                        <li v-for="(ret,index) in modules" :key="index" class="list-group-item">
                                            {{ret.Name.toUpperCase()}}
                                            <span class="btn btn-success btn-sm pull-right" @click="addModule(ret)"><i class="fa fa-plus"></i>  ADD</span>
                                        </li>
                                    </ul>
                                </template>
                                <template v-else-if="type=='Menu'">
                                    <ul class="list-group list-group-x">
                                        <li v-for="(ret,index) in mstmenus" :key="index" class="list-group-item">
                                            {{ret.Name.toUpperCase()}}
                                            <span class="btn btn-success btn-sm pull-right" @click="addMenu(ret)"><i class="fa fa-plus"></i>  ADD</span>
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <table class="table table-bordered table-sm no-bor table-striped">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">No</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Parent</th>
                                        <th style="width: 20px;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in menus" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.MenuName.toUpperCase()}}</td>
                                        <td>{{ret.Type}}</td>
                                        <td>{{ret.ParentName}}</td>
                                        <td class="text-center" style="padding: 2px;">
                                            <button type="button" class="btn btn-danger btn-xs" @click="remove(ret.Id)"><i class="fa fa-times"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="modal" title="NEW MENU">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label class="label-control blue">{{$t('module')}}</label>
                        <div>
                            <select class="form-control form-control-sm" v-model="menu.ParentId">
                                <option v-for="(ret,index) in getModules" :key="index" :value="ret.Id">{{ret.Name.toUpperCase()}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer">
                <b-btn variant="primary" size="sm" @click="saveMenu">{{$t('save')}}</b-btn>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
export default {
    data(){
        return {
            model: {
                Name: ''
            },
            modules: [],
            menus: [],
            mstmenus: [],
            records: [],
            type: 'Module',
            menu: {
                ParentId: ''
            }
        }
    },
    created(){
        this.findById();
        this.moduleList();
        this.menuList();
    },
    methods: {
        findById(){
            let loading = this.$loading.show();
            let id = this.$route.params.id;
            this.$api().post('system/detail/sidebar', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.model = res.data.Json.Sidebar;
                }
            }).finally(() => { loading.hide(); });
        },
        moduleList(){
            this.$api().post('system/modules', { SidebarId: this.$route.params.id }).then(res => {
                this.modules = res.data.Json.Modules;
            });
        },
        menuList(){
            this.$api().post('system/sidebar/menus', { Id: this.$route.params.id }).then(res => {
                this.menus = res.data.Json.Menus;
            });
        },
        sidebarMenuList(){
            this.$api().post('system/menus', { SidebarId: this.$route.params.id }).then(res => {
                this.mstmenus = res.data.Json.Menus;
            });
        },
        onSave(){
            let loading = this.$loading.show();
            this.$api().post('system/save/sidebar', this.model).then(res => {
                if(this.$isValid(res)){
                    this.$router.go(-1);
                }
            }).finally(() => { loading.hide(); });
        },
        addModule(item){
            var req = {
                SidebarId: this.$route.params.id,
                Type: this.type,
                Refs: item.Id
            };
            this.$api().post('system/create/sidebar/menu', req).then(res => {
                if(this.$isValid(res)){
                    Swal.fire('Confirm Message','Module added success.','success');
                    this.moduleList();
                    this.menuList();
                }
            });
        },
        saveMenu(){
            this.$api().post('system/create/sidebar/menu', this.menu).then(res => {
                if(this.$isValid(res)){
                    this.$refs.modal.hide();
                    Swal.fire('Confirm Message','Module added success.','success');
                    this.sidebarMenuList();
                    this.menuList();
                }
            });
        },
        addMenu(item){
            this.menu.Refs = item.Id;
            this.menu.SidebarId = this.$route.params.id;
            this.menu.ParentId = item.ModuleId;
            this.menu.Type = this.type;
            this.$refs.modal.show();
        },
        moduleClick(){
            this.type = 'Module';
            this.moduleList();
        },
        menuClick(){
            this.type = 'Menu';
            this.sidebarMenuList();
        },
        remove(id){
            this.$api().post('system/delete/sidebar/menu', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.menuList();
                }
            });
        }
    },
    computed: {
        getModules(){
            let list = [];
            for(let i = 0; i < this.menus.length; i++){
                let item = this.menus[i];
                if(item.Type == 'Module'){
                    list.push({
                        Id: item.Id,
                        Name: item.MenuName
                    });
                }
            }
            return list;
        }
    }
}
</script>
<style scoped>
    .tree>.tree-filter-empty, .tree>.tree-root{
        padding: 0 !important;
    }
    .btn-group-justified {
        display: flex;
        width: 100%;
    }
    .list-group-x .list-group-item{
        padding: 3px 5px 3px 10px;
        line-height: 28px;
        border-radius: 3px;
        margin-bottom: 3px;
    }
    .btn-xs{
        padding: 0 5px;
    }
</style>